// extracted by mini-css-extract-plugin
export default {"sirBorderRadiusM":"5px","sirGray":"#e3e3e3","card":"Card_card__1aHM0"};